import sanitizeHtml from '@utils/sanitize-html'

/**
 * `v-safe-html` — a sanitizing replacement for `v-html`.
 *
 * Renders the bound HTML string after running it through the allowlist
 * sanitizer, so formatted CMS content can be displayed without exposing the
 * app to XSS (and without a third-party dependency).
 */
function render(el, binding) {
    if (binding.value === binding.oldValue) return
    el.innerHTML = sanitizeHtml(binding.value)
}

export default {
    beforeMount: render,
    updated: render,
}
